// src/components/home/Home.tsx
import React, {useEffect} from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import logger from '../../utils/logger';

const Home: React.FC = () => {
  const { isSignedIn, user } = useAuth();

  useEffect(() => {
    logger.debug('HomePage component mounted - isSignedIn:', isSignedIn);
    if (user) {
      logger.info(`User ${user.name} is viewing the home page.`);
    } else {
      logger.info('Guest user viewing the home page.');
    }
  }, [isSignedIn,user]);

  return (
    <div className="flex flex-col items-center space-y-6 h-screen">
      {isSignedIn ? (
        // --- Signed In View ---
        <div className="space-y-4 text-center">
          <h1 className="text-3xl font-bold">Welcome to Deriq.AI Explorer, {user?.name}!</h1>
          <p>What would you like to explore today?</p> {/* Added prompt */}
          <div className="flex space-x-4 justify-center"> {/* Centered buttons */}
            <Link to="/teams" className="deriq-action-button">
              Go to Teams
            </Link>
            {/* <Link to="/issues/someTeamId" className="deriq-action-button">
              Go to Issues
            </Link> */}
          </div>
        </div>
      ) : (
        // --- Signed Out View ---
        <div className="text-center space-y-4"> {/* Added space-y */}
          <h1 className="text-3xl font-bold">Welcome to Deriq.AI Explorer!</h1>
          {/* Optional: Add Logo here if desired */}
          <p>Get insights from your stack traces or sign in to explore issues.</p>
          <div className="flex space-x-4 justify-center"> {/* Centered buttons */}
            <Link to="/teams" className="deriq-action-button">
              Go to Teams
            </Link>
            {/* 
            6/3/2025 - turn off the direct access functionality
            <Link to="/dstack" className="deriq-action-button">
              Analyze callstack (Dstack)
            </Link>
            <Link to="/dlog" className="deriq-action-button">
              Decode logs
            </Link> */}
            {/* <Link to="/signin" className="deriq-action-button">
              Sign In
            </Link> */}
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;
